var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 0C17.2375 0 0 17.2375 0 38.5C0 59.7625 17.2375 77 38.5 77C59.7625 77 77 59.7625 77 38.5C77 17.2375 59.7625 0 38.5 0ZM55.188 31.99C55.4953 31.6387 55.7292 31.2296 55.8761 30.7866C56.0229 30.3436 56.0796 29.8757 56.043 29.4104C56.0063 28.9452 55.8769 28.492 55.6625 28.0774C55.4481 27.6629 55.1529 27.2955 54.7944 26.9967C54.4359 26.6979 54.0212 26.4739 53.5748 26.3377C53.1284 26.2016 52.6593 26.1561 52.1951 26.2039C51.7309 26.2517 51.2809 26.3919 50.8716 26.6162C50.4623 26.8405 50.1021 27.1444 49.812 27.51L34.762 45.5665L26.9745 37.7755C26.3144 37.1379 25.4303 36.7852 24.5126 36.7931C23.5949 36.8011 22.7171 37.1692 22.0681 37.8181C21.4192 38.4671 21.0511 39.3449 21.0431 40.2626C21.0352 41.1803 21.3879 42.0644 22.0255 42.7245L32.5255 53.2245C32.8694 53.5682 33.2811 53.8365 33.7345 54.0122C34.1878 54.188 34.6727 54.2673 35.1584 54.2453C35.6441 54.2232 36.1199 54.1002 36.5554 53.8841C36.991 53.6679 37.3767 53.3634 37.688 52.99L55.188 31.99Z",
    fill: "#009262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.f4f852be1bb97d4c2b3b3bdbc98efb45.svg";
export { ForwardRef as ReactComponent };